<div class="genesys-call-log-container" data-qa="genesys-call-log_search">
  <div class="genesys-call-log__content">
    <div class="genesys-call-log__search">
      <div class="genesys-call-log__search--left">
        <horizon-icon
          iconName="phone"
          [iconColor]="globalSettings.colors.mainColor"
          [size]="'15'"
        ></horizon-icon>
        <span
          >{{
            "call_log.call_log_search_view.labels.number_calling" | translate
          }}
          :</span
        >
        <span
          class="genesys-call-log__number"
          [ngClass]="
            (isKnowCaller || isThirdPartyCall) &&
            'genesys-call-log__number--known'
          "
        >
          {{ genesysData.phoneNumber }}
        </span>
      </div>
      <div
        class="genesys-call-log__search--right"
        *ngIf="isKnowCaller || isThirdPartyCall"
      >
        <horizon-icon
          class="genesys-call-log__icon"
          iconName="checked"
          iconGroup="checkmark"
          [size]="'15'"
          [iconColor]="globalSettings.colors.successColor"
        ></horizon-icon>
        <span>{{
          "call_log.call_log_search_view.labels.registered" | translate
        }}</span>
      </div>
      <div
        class="genesys-call-log__search--right"
        *ngIf="!isKnowCaller && !isThirdPartyCall"
      >
        <horizon-icon
          class="genesys-call-log__icon"
          iconName="cancel"
          iconGroup="actions"
          [size]="'15'"
          [iconColor]="globalSettings.colors.errorColor"
        ></horizon-icon>
        <span>{{
          "call_log.call_log_search_view.labels.unregistered" | translate
        }}</span>
      </div>
      <div class="genesys-call-log__search--bottom">
        <horizon-generic-grid
          data-qa="genesys-call-log_search_grid_caller"
          [applyCellCustomization]="true"
          [cellContentColor]="globalSettings.colors.mainColor"
          [users]="users"
          [gridData]="customerData"
          [gridColumns]="customerTemplate"
          [gridConfigSettings]="callLogGridConfigService.genericGridSettings"
          [preselectFirstRow]="preselectFirstRow"
        ></horizon-generic-grid>
      </div>
    </div>
    <form
      [formGroup]="searchForm"
      data-qa="genesys-call-log_search_form"
      class="genesys-call-log__form"
    >
      <div class="genesys-call-log__form-group--row">
        <ng-container>
          <horizon-checkbox-input
            data-qa="genesys-call-log_search_form_checkbox_unauthorised"
            name="isUnauthorised"
            [checked]="isUnauthorised"
            [disabled]="isThirdPartyCall"
            (valueClicked)="onUnauthorisedChange()"
          ></horizon-checkbox-input>
          <label for="isUnauthorised" class="linked-account__text">
            {{
              "call_log.call_log_search_view.labels.unauthorised_caller"
                | translate
            }}
          </label>
        </ng-container>

        <ng-container>
          <horizon-checkbox-input
            data-qa="genesys-call-log_search_form_checkbox_third-party-panel"
            name="isThirdPartyPanel"
            [checked]="isThirdPartyPanel"
            [disabled]="isThirdPartyCall"
            (valueClicked)="on3rdPartyPanelChange()"
          ></horizon-checkbox-input>
          <label for="isThirdPartyPanel" class="linked-account__text">
            {{
              "call_log.call_log_search_view.labels.3rd_party_panel" | translate
            }}
          </label>
        </ng-container>
      </div>
      <div class="genesys-call-log__form-group--row">
        <horizon-checkbox-input
          data-qa="genesys-call-log_search_form_checkbox_transfer"
          name="isTransfer"
          [disabled]="isThirdPartyCall"
          (valueClicked)="onTransferChange()"
        ></horizon-checkbox-input>
        <label for="isTransfer" class="linked-account__text">
          {{ "call_log.call_log_search_view.labels.is_transfer" | translate }}
        </label>
      </div>
      <div class="genesys-call-log__form-group">
        <horizon-text-input
          [control]="searchForm.controls['name']"
          [label]="'call_log.call_log_search_view.labels.search_name'"
        ></horizon-text-input>
      </div>
      <div class="genesys-call-log__form-group">
        <horizon-number-input
          [format]="'###'"
          [showSpinButton]="false"
          [label]="'call_log.call_log_search_view.labels.account_number'"
          [control]="searchForm.controls['accountNumber']"
        ></horizon-number-input>
      </div>
      <div class="genesys-call-log__form-group--row">
        <horizon-button
          #searchButton
          data-qa="genesys-call-log_search_form_button_search"
          class="genesys-call-log__search-button"
          [text]="'call_log.call_log_search_view.labels.search' | translate"
          [type]="'info'"
          [buttonColor]="globalSettings.colors.mainColor"
          (clickEvent)="onSubmit()"
        ></horizon-button>
      </div>
    </form>
  </div>
  <div
    *ngIf="!isThirdPartyPanel"
    class="genesys-call-log__content"
    data-qa="genesys-call-log_search_results"
  >
    <div class="genesys-call-log__grid-header">
      <span>{{
        "call_log.call_log_search_view.labels.results" | translate
      }}</span>
      <div class="genesys-call-log__separator"></div>
    </div>
    <div class="genesys-call-log__grid">
      <horizon-generic-grid
        data-qa="genesys-call-log_search_grid_results"
        [applyCellCustomization]="true"
        [cellContentColor]="globalSettings.colors.mainColor"
        [users]="users"
        [gridData]="resultsData"
        [gridColumns]="resultsTemplate"
        [gridConfigSettings]="callLogGridConfigService.gridSettings"
        (rowSelectedEvent)="onCustomersRowActionEvent($event)"
      ></horizon-generic-grid>
    </div>
  </div>
  <div
    *ngIf="isThirdPartyPanel"
    class="genesys-call-log__content"
    data-qa="genesys-call-log_search_third-parties"
  >
    <div class="genesys-call-log__grid-header">
      <span>{{
        "call_log.call_log_search_view.labels.results" | translate
      }}</span>
      <div class="genesys-call-log__separator"></div>
    </div>
    <div class="genesys-call-log__grid--third-parties">
      <horizon-notification-msg
        [type]="'warning'"
        [text]="'call_log.call_log_search_view.labels.third_parties_prompt'"
      ></horizon-notification-msg>
      <horizon-generic-grid
        data-qa="genesys-call-log_search_grid_accounts"
        [applyCellCustomization]="true"
        [cellContentColor]="globalSettings.colors.mainColor"
        [users]="users"
        [gridData]="accountData"
        [gridColumns]="accountTemplate"
        [gridConfigSettings]="
          callLogGridConfigService.genericPaginationGridSettings
        "
        (rowSelectedEvent)="onSelectAccountsRowActionEvent($event)"
        (rowDeselectedEvent)="onDeselectAccountsRowActionEvent($event)"
      ></horizon-generic-grid>
      <horizon-generic-grid
        data-qa="genesys-call-log_search_grid_third-parties"
        [applyCellCustomization]="true"
        [cellContentColor]="globalSettings.colors.mainColor"
        [users]="users"
        [gridData]="thirdPartyData"
        [gridColumns]="thirdPartyTemplate"
        [gridConfigSettings]="
          callLogGridConfigService.genericPaginationGridSettings
        "
        (rowSelectedEvent)="onSelectThirdPartiesRowActionEvent($event)"
        (rowDeselectedEvent)="onDeselectThirdPartiesRowActionEvent($event)"
      ></horizon-generic-grid>
    </div>
  </div>
  <div class="genesys-call-log__content">
    <horizon-button
      #openCallLogButton
      data-qa="genesys-call-log_search_button_open-call-log"
      [buttonColor]="globalSettings.colors.mainColor"
      [isDisabled]="!isCallerSelected"
      [text]="'Call Log'"
      [type]="'info'"
      (clickEvent)="openCallLog()"
    ></horizon-button>
  </div>
  <div
    class="genesys-call-log__content"
    *ngIf="isCallerSelected && !isThirdPartyPanel"
    data-qa="genesys-call-log_search_recent-calls"
  >
    <div class="genesys-call-log__grid-header">
      <span
        >{{
          "call_log.call_log_search_view.labels.recent_calls"
            | translate : { customerDisplayName: customerDisplayName }
        }}
      </span>
      <div class="genesys-call-log__separator"></div>
    </div>
    <horizon-generic-grid
      data-qa="genesys-call-log_search_grid_recent-calls"
      [applyCellCustomization]="true"
      [cellContentColor]="globalSettings.colors.mainColor"
      [users]="users"
      [gridData]="recentCallsData"
      [gridColumns]="recentCallsTemplate"
      [gridConfigSettings]="callLogGridConfigService.genericGridSettings"
    ></horizon-generic-grid>
  </div>
</div>
